import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import "react-widgets/styles.css";
import { Col, Label, Row, Table } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    Afr, Audit, AffiliateReporting, getSelectedAfr
} from '../../redux/AfrSlice';
import { Auditor, AuditorReference, loadAuditor, selectAuditor } from '../../redux/AuditorSlice';
import { getAllAuditorsAsync, selectAuditors } from '../../redux/AuditorsSlice';
import { DocumentReference, DocumentRelationship, selectDocuments } from '../../redux/DocumentsSlice';
import { setIsDirty } from '../../redux/MiscSlice';
import dateHelper from '../../utils/dateHelper';
import enums from '../../utils/enums';
import phoneHelper from '../../utils/phoneHelper';
import utilityHelper from '../../utils/utilityHelper';
import AddressViewer from '../feature/AddressViewer';
import UploadDocumentByRole from './UploadDocumentByRole';
import { AdminUserRoleEnum, selectAdminUserRole } from '../../redux/UserSlice';


const AuditEditor = (props:
    {
        containerParentOfAudit: any,        /* it can be an instance of Affiliated Entity or the AFR current Version */
        containerType: string,             /* for now it can be Affiliated Entity or Audit */
        saveAudit: any
    }
) => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const dispatch = useAppDispatch();
    const lastUploadedDocument: DocumentReference = useAppSelector(selectDocuments);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const adminUserRole: AdminUserRoleEnum | null = useAppSelector(selectAdminUserRole);

    const [auditDate, setAuditDate] = useState<any>();
    const [auditDateFormatted, setAuditDateFormatted] = useState("");
    const [auditReceivedDate, setAuditReceivedDate] = useState<string | null>(null);
    const [auditCode, setAuditCode] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [sendAuditPdf, setSendAuditPdf] = useState(false);
    const [pdfDocumentId, setPDFDocumentId] = useState("");
    const [file, setFile] = useState<File | null>(null);
    const auditDateRef = useRef(null);


    const [startDate, setStartDate] = useState(new Date());

    const selectedAuditor: Auditor | null = useAppSelector(selectAuditor);
    const auditorsList = useAppSelector(selectAuditors);


    const [hasAudit, setHasAudit] = useState((props.containerParentOfAudit && props.containerParentOfAudit.audit) ? true : false);

    var pdfType: string = enums.pdfType.AFRAudit;

    if (props.containerType === enums.auditSource.affiliatedEntity) {
        pdfType = enums.pdfType.AffiliatedEntityAudit;
    }


    const getAuditorList = function () {
        var newList: any[] = [];
        var newOrderedList = [...auditorsList];
        // todo: sort the list by label
        newOrderedList.sort((a, b) => a.name > b.name ? 1 : -1);

        var currentName: string = "";
        var count = 0;
        var countChildren: number =0;
        var children: any[] = [];

        for (var auditor of newOrderedList) {

            count = newOrderedList.filter(function (value) {
                return value.name === auditor.name;
            }).length;

            if (currentName != auditor.name) {
                countChildren = 1;
                if (count === 1) {
                    newList.push({ label: auditor.name, value: auditor.code, children: [] });
                } else {
                    children.push({ label: auditor.name + " [" + auditor.branchId + "]", value: auditor.code, disabled: false, children: [] });
                }
            } else {

                if (countChildren === count) {
                    children.push({ label: auditor.name + " [" + auditor.branchId + "]", value: auditor.code, disabled: false, children: [] });
                    newList.push({ label: auditor.name, value: auditor.code, children: children, disabled: true, expanded: true });
                    children = [];
                } else {
                    children.push({ label: auditor.name + " [" + auditor.branchId + "]", value: auditor.code, disabled: false, children: [] });
                }
            }
            countChildren = countChildren + 1;
            currentName = auditor.name;
        }
        return newList;
    }


    const ddhandleChange = function (currentNode: any, selectedNodes: any) {
        var audit: Audit | null = null;

        var newAuditor = auditorsList.find((e: any) => e.code === currentNode.value);

        if (props.containerParentOfAudit.audit) {

            audit = JSON.parse(JSON.stringify(props.containerParentOfAudit.audit));
            if (audit != null) {
                audit.auditorReference = { name: newAuditor.name, code: newAuditor.code, branchId: newAuditor.branchId };
            }
        } else {
            audit = {
                auditorReference: { name: newAuditor.name, code: newAuditor.code, branchId: newAuditor.branchId },
                auditPdf: null,
                auditType: "",
                datePerformed: null,
                sendAuditPdf: null,
                dateReceived: null,
            }
        }

        // select the new auditor
        dispatch(loadAuditor(currentNode.value));

        setAuditCode(currentNode.value);

        // Turn ON the dirty flag in redux
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        //send back to the caller to save each change to the audit object
        props.saveAudit(audit);
    }


    const handleChange = function (dateEntered: any) {

        // for now we assume that there are no error in the typed date
        var audit;
        if (isNaN(Date.parse(dateEntered))) {
            return;
        }
        var date = dateHelper.formatDateToISO(dateEntered);

        if (props.containerParentOfAudit.audit) {
            audit = JSON.parse(JSON.stringify(props.containerParentOfAudit.audit));
            audit.datePerformed = date;
        } else {
            audit = { auditorReference: null, auditPdf: null, auditType: null, datePerformed: date, sendAuditPdf: null, dateReceived: null }
        }

        // Turn ON the dirty flag in redux
        dispatch(setIsDirty({ IsDirty: true, Page: "" }));

        setAuditDate(dateEntered);

        //send back to the caller to save each change to the audit object in redux
        props.saveAudit(audit);

    }



    useEffect(() => {
        if (!auditorsList || auditorsList.length === 0) {
            dispatch(getAllAuditorsAsync());
        }
    }, []);

    useEffect(() => {

        if (selectedAuditor) {
            if (selectedAuditor.info) {
                setPhone(phoneHelper.formatPhoneNumber(selectedAuditor.info.number.number) + (selectedAuditor.info.number.extension ? ", ext: " + selectedAuditor.info.number.extension : ""));
            } else {
                setPhone("");
            }

        }

    }, [selectedAuditor])


    useEffect(() => {
        var aud: Audit | null = null;
        if (currentAfr) {
            var parts: string[] = props.containerType.split("^");
            switch (parts[0]) {
                case enums.auditSource.AFRCurrentVersion:
                    aud = currentAfr.currentversion.audit;
                    break;

                case enums.auditSource.affiliatedEntity:
                    if (parts[1].length > 1 && currentAfr.affiliateReporting) {
                        var affReporting : AffiliateReporting | undefined = currentAfr.affiliateReporting.find(arept => arept.affiliateReference && (arept.affiliateReference.code === parts[1]));
                        if (affReporting && affReporting && affReporting.audit) {
                            aud = affReporting.audit;
                        }
                    }
                    break;
            }
        }
        setHasAudit(aud ? true : false);

        setAuditDate(null);
        setAuditDateFormatted("");
        setAuditReceivedDate(null);
        setAuditCode("");
        setAddress("");
        setPhone("");
        setSendAuditPdf(false);
        setPDFDocumentId("");


        if (aud) {

            // get the auditor information            
            //setAuditDate(dateHelper.stringToDate(props.containerParentOfAudit.audit.datePerformed));
            var newAuditDate = aud.datePerformed ? dateHelper.convertToDate(aud.datePerformed) : null;
            if (newAuditDate !== null) {
                setAuditDate(newAuditDate);
            }

            setAuditDateFormatted(aud.datePerformed ? dateHelper.stringDateInFormat(aud.datePerformed, "LL/dd/yyyy") : "");
            setSendAuditPdf((aud.sendAuditPdf) ? true : false);
            if (aud.auditPdf) {
                var pdf: DocumentRelationship = aud.auditPdf;
                setPDFDocumentId((pdf.documentId && pdf.documentId.length > 0) ? pdf.documentId : "No Document");
                setAuditReceivedDate(dateHelper.stringDateInFormat(pdf.timestamp, "LL/dd/yyyy HH:m"))
            }
            if (aud.auditorReference) {
                setAuditCode(aud.auditorReference.code);
                dispatch(loadAuditor(aud.auditorReference.code)).then((result: any) => {
                    var auditor = result.payload;
                    setAuditCode(auditor.code);
                    setAddress(auditor.address);
                    if (auditor.info && auditor.info.number) {
                        setPhone(phoneHelper.formatPhoneNumber(auditor.info.number.number) + (auditor.info.number.extension ? ", ext: " + auditor.info.number.extension : ""));
                    }
                });
            } else {
                dispatch(loadAuditor(""));
            }


        }

    }, [currentAfr])

    React.useEffect(() => {

        if (props.containerType) {
            if (props.containerType.includes(enums.auditSource.affiliatedEntity)){
                if (props.containerParentOfAudit) {

                    setAuditDate(null);
                    const affiliateValue = props.containerParentOfAudit as AffiliateReporting;

                    if (affiliateValue) {
                        if (affiliateValue.audit) {
                            if (affiliateValue.audit.datePerformed) {
                                var newAuditDate = affiliateValue.audit.datePerformed ? dateHelper.convertToDate(affiliateValue.audit.datePerformed) : null;
                                if (newAuditDate !== null) {
                                    setAuditDate(newAuditDate);
                                }
                            }
                        }
                    }
                }
            }
        }

    }, [props.containerParentOfAudit])


    return (
        <React.Fragment>
            <Row>
                <Col>
                    {hasAudit && (
                        <div>
                            <Row>
                                <Col md="4">
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>Independent Auditor's Report Date</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>

                                                    <DatePicker
                                                        selected={auditDate}
                                                        dateFormat="MM/dd/yyyy"
                                                        onChange={handleChange}
                                                        className="red-border"
                                                        disabled={utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                                            || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                        maxDate={new Date()}
                                                    />
                                                </td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </Col>
                                <Col md="8">
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th colSpan={2} align={'center'}>Auditor Information</th>

                                                <td colSpan={2} align={'left'}>

                                                        <Row>
                                                            <Col>
                                                                <DropdownTreeSelect data={getAuditorList()}
                                                                    mode="radioSelect" keepTreeOnSearch={true}
                                                                    onChange={ddhandleChange}
                                                                disabled={utilityHelper.checkStatusList(currentAfr, enums.verifiedCertifiedRecertified)
                                                                    || (adminUserRole === AdminUserRoleEnum.Reviewer || adminUserRole === AdminUserRoleEnum.Admin)}
                                                                texts={{ placeholder: "*Choose Auditor..." }} />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="text-left">
                                                                <small>*If unable to locate the CPA firm or address, please submit a CPA Firm Bypass Request from the Bypass Tab on the Summary Page.</small>
                                                            </Col>
                                                        </Row>


                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Firm Name</th>
                                                <th>Zip Code</th>
                                                <th>Phone</th>
                                                <th>Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Label>{selectedAuditor && selectedAuditor.name}</Label>
                                                </td>
                                                <td><Label>{selectedAuditor && selectedAuditor.branchId}</Label></td>
                                                <td>
                                                    <Label>{phone}</Label>
                                                </td>
                                                <td>{selectedAuditor && selectedAuditor.address &&
                                                    (<AddressViewer
                                                        street={selectedAuditor.address.street}
                                                        poBox={selectedAuditor.address.pobox} state={""}
                                                        zipCode={selectedAuditor.address.zip}
                                                    city={selectedAuditor.address.city != null ? selectedAuditor.address.city.name : ""} />)}
                                                </td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr /> 
                                </Col>
                            </Row>
                            <>
                                <UploadDocumentByRole role={enums.documentRole.audit} containerParentOfAudit={props.containerParentOfAudit} pdfType={pdfType} saveAudit={props.saveAudit} />
                            </>
                            
                        </div>)}
                </Col>
            </Row>
        </React.Fragment>
    )

}

export default AuditEditor;